import { IFormElement } from '../types';

export const getFieldComponent = (element: IFormElement): string => {
  const { type, inputType } = element;

  switch (type) {
    case 'text':
      switch (inputType) {
        case 'email':
          return 'email';
        case 'url':
          return 'url';
        case 'number':
          return 'number';
        case 'date':
          return 'date';
        case 'datetime-local':
          return 'datetime';
        case 'tel':
          return 'tel';
        case 'password':
          return 'password';
        default:
          return 'text';
      }
    case 'comment':
      return 'textarea';
    case 'dropdown':
      return 'dropdown';
    case 'radiogroup':
      return 'radiogroup';
    case 'checkbox':
      return 'checkbox';
    case 'boolean':
      return 'boolean';
    case 'file':
      return 'file';
    case 'imagepicker':
      return 'imagepicker';
    case 'rating':
      return 'rating';
    case 'ranking':
      return 'ranking';
    case 'matrix':
      return 'matrix';
    case 'matrixdropdown':
      return 'matrixdropdown';
    case 'matrixdynamic':
      return 'matrixdynamic';
    case 'multipletext':
      return 'multipletext';
    case 'tagbox':
      return 'tagbox';
    default:
      return 'text';
  }
};
